export const TIMESTAMP_DIVISOR = 1000000000;
